import { render, staticRenderFns } from "./_base-simple-table.vue?vue&type=template&id=0bdcee52&scoped=true"
import script from "./_base-simple-table.vue?vue&type=script&lang=js"
export * from "./_base-simple-table.vue?vue&type=script&lang=js"
import style0 from "./_base-simple-table.vue?vue&type=style&index=0&id=0bdcee52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcee52",
  null
  
)

export default component.exports